import "bootstrap/dist/css/bootstrap.min.css";
import React, {useEffect, useState} from "react";
import rapidex from '../images/rapidex.png';
import caixaAssistencia from '../images/caixa_assistencia.png';
import { IMaskInput } from "react-imask";
import { isPropostasCpfCnpj } from "../componentes/api/DataApi";
import Skeleton from 'react-loading-skeleton'
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

export default function PesquisaFiltroPage() {
    const navigate = useNavigate();

    const [mask, setMask] = useState("000.000.000-00");
    const [value, setValue] = useState("");
    const [type, setType] = useState("F");
    const [loading, setLoading] = useState(false);
    const [notExists, setNotExists] = useState(false);

    const onChangeMask = (type, mask) => {
        setValue("");
        setType(type);
        setMask(mask);
    }

    const onFindCpfCnpj = () => {
        if (value) {
            setLoading(true);

            let strValue = replaceAll(replaceAll(replaceAll(value, ".", ""), "-", ""), "/", "");

            isPropostasCpfCnpj(strValue, (response) => {
                setLoading(false);

                if (response && response.codigo === 0 && response.existeVendas) {
                    navigate("/proposta?cpf="+strValue);
                }
                else {
                    setNotExists(true);
                }
            });
        }
    }

    return (
        <>
        {loading &&
            <>
                <div className="d-flex flex-column w-100 align-items-center">
                    <div className="d-flex flex-column bg-padrao align-items-center" style={{ width: "1150px" }}>
                        <div className="d-flex flex-column" style={{ width: "100%" }}>
                            <Skeleton count={40} height={"20px"} />
                        </div>
                    </div>
                </div>
            </>
        }

        {!loading &&
            <>
            <div className="d-flex flex-column w-100 align-items-center h-full">
                <div className="d-flex flex-column bg-padrao align-items-center h-full" style={{width: "1150px"}}>
                    <div className="d-flex flex-row justify-content-between w-100">
                        <div style={{marginLeft: "10px", marginTop: "10px"}}>
                            <img src={rapidex} alt=""></img>
                        </div>
                        <img src={caixaAssistencia} alt=""></img>
                    </div>

                    <div style={{marginTop: "200px", marginBottom: "300px"}}>
                        <div className="d-flex flex-column">
                            <div className="d-flex flex-row">
                                <input type="radio" name="pessoa" className="me-1" onChange={() => onChangeMask("F", "000.000.000-00")} checked={type === "F"}/><label className="me-3">CPF</label>
                                <input type="radio" name="pessoa" className="me-1" onChange={() => onChangeMask("J", "00.000.000/0000-00")} checked={type === "J"}/><label className="me-3">CNPJ</label>
                            </div>
                            <div className="d-flex flex-row">
                                <IMaskInput id="tbxPesquisa"
                                            mask={mask}
                                            className="me-2"
                                            value={value}
                                            onBlur={(e) => setValue(e.target.value)}
                                            onChange={(e) => setValue(e.target.value)}></IMaskInput>
                                <button className="botaoNovaProposta" style={{width: '80px'}} onClick={() => onFindCpfCnpj()}>Pesquisar</button>
                            </div>

                            <div className="d-flex flex-column align-items-center" style={{marginTop: "50px"}}>
                                <div style={{marginTop: "30px"}}>
                                    <span className="chat_apoio">Chat de Apoio à Rede</span>
                                </div>
                                <div>
                                    <span className="chat_apoio_parceira">Chat de Apoio à Rede Caixa e Rede Parceira</span>
                                </div>
                                <div>
                                    <button className="botao_chat_online" onClick={() => window.location.href='https://atendimentolojista.caixaassistencia.com.br/'}>Chat Online</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={notExists} centered={true}>
                <Modal.Header className="cabecalho_modal">
                    Atenção:
                </Modal.Header>
                <Modal.Body>
                    <div className="w-100">
                        <center>
                            <b>Não consta nenhuma proposta!</b>
                        </center>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex flex-row">
                        <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={() => setNotExists(false)}>Fechar</button>
                    </div>
                </Modal.Footer>
            </Modal>
            </>
        }
        </>
    )
}
